'use client';

import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';

import { useClientHasRendered } from '../../helpers/hooks';
import { URLParameters } from '../Onboarding/constants/url/urlParameters';
import { useCastle } from '../../helpers/hooks/useCastle';

const DynamicAuthentication = dynamic(
  async () => import('./Authentication').then(mod => mod.Authentication),
  { ssr: false },
);

export const AuthenticationWrapper = () => {
  const queryParams = useSearchParams();
  const clientHasRendered = useClientHasRendered();
  const initialFlow = queryParams?.get(URLParameters.Flow) ?? null;

  useCastle(); // Initialize Castle here so that we can start observing user behavior

  return clientHasRendered &&
    queryParams &&
    !queryParams.has(URLParameters.Company) &&
    queryParams.get(URLParameters.Flow) ? (
    <DynamicAuthentication initialFlow={initialFlow} />
  ) : (
    <></>
  );
};
